import classNames from "classnames"
import { useState, useEffect, useRef } from "react"
import { Control, useFieldArray } from "react-hook-form"
import { FormValues } from "."
import PermissionCheckboxGroup from "./_checkbox-group"

interface ModulePermissionSectionProps {
    role: any
    roleIndex: number
    control: Control<FormValues, any>
    isOpen?: boolean
}

export default function ModulePermissionSection({
    role,
    roleIndex,
    control,
    isOpen = false
}: ModulePermissionSectionProps) {
    // Use ref to track if this is the first render
    const isFirstRender = useRef(true)
    const [open, setOpen] = useState<boolean>(isOpen)

    // Only update state from prop on first render
    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false
            setOpen(isOpen)
        }
    }, [])

    const { fields } = useFieldArray({
        control,
        name: `roles.${roleIndex}.modules`,
    })

    return (
        <div className="rounded-md border border-stroke p-4 shadow-9 dark:border-strokedark dark:shadow-none sm:p-6">
            <button
                type="button"
                className="flex w-full items-center gap-1.5 sm:gap-3 xl:gap-6 active"
                onClick={() => setOpen(!open)}
            >
                <div className="flex h-10.5 w-full max-w-10.5 items-center justify-center rounded-md bg-[#F3F5FC] dark:bg-meta-4">
                    <i className={classNames("fa-solid fa-chevron-up transition-transform", { "fa-rotate-180": open })} />
                </div>
                <div>
                    <h4 className="text-left uppercase font-semibold text-black dark:text-white">
                        {role.roleName}
                    </h4>
                </div>
            </button>

            <div className={classNames("mt-5 ml-16.5 duration-200 ease-in-out", { "block": open, "hidden": !open })}>
                <div className="space-y-6">
                    {fields.map((moduleField, moduleIndex) => (
                        <PermissionCheckboxGroup
                            key={moduleField.id}
                            module={moduleField}
                            roleIndex={roleIndex}
                            moduleIndex={moduleIndex}
                            control={control}
                            roleId={role.roleId}
                        />
                    ))}
                </div>
            </div>
        </div>
    )
}
